export const WELCOME_BLOCK_NAME = "custom-welcome-screen";
export const FIRST_NAME_ERROR_MESSAGE = "Enter valid first name";
export const SECOND_NAME_ERROR_MESSAGE = "Enter valid last name";
export const AB_TEST_4_1_HEADER_PARAM_VALUE = "t4-1";
export const AB_TEST_4A_1_HEADER_PARAM_VALUE = "t4a-1";
export const AB_TEST_4A_2_HEADER_PARAM_VALUE = "t4a-2";
export const AB_TEST_6_HEADER_PARAM_VALUE = "t6";
export const AB_TEST_10_1_HEADER_PARAM_VALUE = "t10-1";
export const AB_TEST_10_2_HEADER_PARAM_VALUE = "t10-2";
export const AB_TEST_22_1_PARAM_VALUE = "t22-1";
export const AB_TEST_22_2_PARAM_VALUE = "t22-2";
